import { Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';
import { formatCurrency } from '@iheartjane/utils';
import { useContext } from 'react';

import { SpecialsModalContext } from '@jane/business-admin/providers';
import type { SpecialTypeConditionsInputProps } from '@jane/business-admin/types';

export const SpendingThreshold = ({
  isCreateMode,
  name,
  options,
}: SpecialTypeConditionsInputProps['spending_threshold'] & {
  isCreateMode: boolean;
}) => {
  const {
    posSyncMap: { isJanePosSynced, posSynced },
    isReadOnly,
  } = useContext(SpecialsModalContext);

  const { getValues } = useFormContext();
  const spendingThreshold = getValues('display.spending_threshold');

  const showInputs = (isJanePosSynced || !posSynced) && !isReadOnly;

  return (
    <Flex justifyContent="space-between" width="100%">
      {options?.map((option) => {
        return isCreateMode || (!isCreateMode && showInputs) ? (
          <Flex width="100%" key={option.value} mb={24}>
            <Form.NumberField
              width="100%"
              name={`${name}.${option.value}`}
              label={option.label}
              defaultValue={getValues(`${name}.${option.value}`) || 1}
              min={1}
              required
              disableOnWheel
              allowedDecimalPlaces={option.rule === 'required_rules' ? 2 : 0}
              step={option.rule === 'required_rules' ? 0.01 : 1}
              startUnit={option.rule === 'required_rules' ? '$' : ''}
            />
          </Flex>
        ) : (
          <Flex flexDirection="column" width="50%" key={option?.value} mb={24}>
            <Typography
              color="grays-black"
              variant="body-bold"
              data-testid={`non-janepos-synced-spending-threshold-${
                option.rule === 'required_rules' ? 'required' : 'discounted'
              }`}
            >
              {option?.label}
            </Typography>
            <Typography color="grays-black" variant="body" mt={4}>
              {option.rule === 'required_rules'
                ? formatCurrency(spendingThreshold?.[option?.value])
                : spendingThreshold?.[option?.value] || 'N/A'}
            </Typography>
          </Flex>
        );
      })}
    </Flex>
  );
};
